import React from "react";
import Table from "rc-table";
import "./SinglePriceTable.scss";

interface SinglePriceItem {
  sku: string;
  priceBefore: string;
  priceAfter: string;
}

interface SinglePriceTableProps {
  items: SinglePriceItem[];
  userName: string;
  changeDate: string;
}

const SinglePriceTable: React.FC<SinglePriceTableProps> = ({
  items,
  userName,
  changeDate,
}) => {
  const formatPrice = (price: string) => {
    if (!price || price === "0.00") {
      return "-";
    }
    return `${price} zł`;
  };

  // Create table data with merged cells for date and user
  const tableData = items.map((item, index) => ({
    key: item.sku,
    sku: item.sku,
    priceBefore: item.priceBefore,
    priceAfter: item.priceAfter,
    changeDate: index === 0 ? changeDate : null,
    userName: index === 0 ? userName : null,
    isFirstRow: index === 0,
    rowSpan: index === 0 ? items.length : 0,
  }));

  const columns = [
    {
      title: "DATA ZMIANY",
      dataIndex: "changeDate",
      key: "changeDate",
      render: (value: string | null, record: any) => {
        if (record.isFirstRow) {
          return {
            children: value,
            props: {
              rowSpan: items.length,
            },
          };
        }
        return {
          children: null,
          props: {
            rowSpan: 0,
          },
        };
      },
    },
    {
      title: "ZAKTUALIZOWANE SKU",
      dataIndex: "sku",
      key: "sku",
    },
    {
      title: "CENA PRZED",
      dataIndex: "priceBefore",
      key: "priceBefore",
      render: (price: string) => formatPrice(price),
    },
    {
      title: "CENA PO",
      dataIndex: "priceAfter",
      key: "priceAfter",
      render: (price: string) => formatPrice(price),
    },
    {
      title: "UŻYTKOWNIK WPROWADZAJĄCY",
      dataIndex: "userName",
      key: "userName",
      render: (value: string | null, record: any) => {
        if (record.isFirstRow) {
          return {
            children: value,
            props: {
              rowSpan: items.length,
            },
          };
        }
        return {
          children: null,
          props: {
            rowSpan: 0,
          },
        };
      },
    },
  ];

  const mobileColumns = [
    {
      title: "Pozycje",
      key: "mobile",
      render: (_: any, record: any) => (
        <div className="mobile-item">
          <div className="mobile-item__sku">{record.sku}</div>
          <div className="mobile-item__prices">
            <span className="price-before">
              {formatPrice(record.priceBefore)}
            </span>
            →
            <span className="price-after">
              {formatPrice(record.priceAfter)}
            </span>
          </div>
        </div>
      ),
    },
  ];

  return (
    <div className="single-price-table">
      <Table
        rowKey="key"
        className="prices-table desktop-table"
        data={tableData}
        columns={columns}
        emptyText="Brak danych do wyświetlenia"
      />

      <Table
        rowKey="key"
        className="mobile-table"
        data={tableData}
        columns={mobileColumns}
        showHeader={false}
      />
    </div>
  );
};

export default SinglePriceTable;
